import React from 'react';
import { Container, MarginBox, Box } from './CardsBox.style';
import CardTitle from '../CardTitle/CardTitle';
import { useTranslation } from 'react-i18next';

export const CardsBox = ({ items }) => {
    //const { t } = useTranslation();
    return (
    <Container>
        <MarginBox>
        {items.map(card => (
            <Box key={card.key} columnPosition={card.columnPosition}>
            <CardTitle   
                marginTop={card.marginTop}
                image={card.image}
                text={card.text}
            />
            </Box>
        ))}
        </MarginBox>
    </Container>
  );
};

export const CardsBoxPart = ({items}) => {
  const { t } = useTranslation();
    return (
    <Container>
        <MarginBox>
        {items.map(card => (
            <Box key={card.key} columnPosition={card.columnPosition}>
            <CardTitle image={card.image} text={t(card.text)} />
            </Box>
        ))}
        </MarginBox>
    </Container>
  );
};
